import { Accordion } from "@szhsin/react-accordion";
import { convertSearchParamsToObject } from "helpers";
import { Fragment } from "react";
import { createSearchParams, useSearchParams } from "react-router-dom";
import { SelectableItem, SelectableList } from "ui";

import { FilterAccordion } from "../FilterAccordion";
import { AdditionalAttributeFilterProps } from "./AdditionalAttributesFilters.types";

import styles from "../../ProductsFilter.module.scss";

const AdditionalAttributeFilter = ({
  additionalAttribute
}: AdditionalAttributeFilterProps) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const attributeSearchParameterValues = searchParams.getAll(
    String(additionalAttribute.id)
  );

  const options = additionalAttribute.values.map((attributeValue) => ({
    label: attributeValue.value,
    value: attributeValue.id as string
  }));

  const selectedOptions = options.filter((option) =>
    attributeSearchParameterValues.includes(option.value)
  );

  const onClearClick = () => {
    searchParams.delete(String(additionalAttribute.id));
    setSearchParams(searchParams);
  };

  const onSelectableColorsListChange = (
    selectableOptions: SelectableItem[]
  ) => {
    const existingParams = convertSearchParamsToObject(searchParams);
    const newAttributeParameterValue = selectableOptions.map(
      (option) => option.value
    );

    setSearchParams(
      createSearchParams({
        ...existingParams,
        [String(additionalAttribute.id)]: newAttributeParameterValue
      })
    );
  };

  return (
    <Fragment key={additionalAttribute.id}>
      <Accordion transition transitionTimeout={250}>
        <FilterAccordion
          header={additionalAttribute.name}
          isClearDisplay={selectedOptions.length > 0}
          onClearClick={onClearClick}
        >
          <SelectableList
            values={selectedOptions}
            options={options}
            onChange={onSelectableColorsListChange}
          />
        </FilterAccordion>
      </Accordion>

      <div className={styles.filter_separatorLine} />
    </Fragment>
  );
};

export default AdditionalAttributeFilter;
